import React from 'react';
import { ClockIcon, FilmIcon, HelpCircleIcon, ClipboardListIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = [FilmIcon, HelpCircleIcon, ClipboardListIcon, ClockIcon];
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-pitch" data-id="element-128" data-mp="2vqr69zq2hz5k">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-129" data-mp="2voo82sergzpr">
        <p className="inline-block rounded-md bg-pitch px-2 py-0.5 font-sub text-sm font-extrabold text-gold" data-id="element-130" data-mp="39gb6oyw6ekbp">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.6rem] font-normal uppercase leading-[1.1] sm:text-4xl" data-id="element-131" data-mp="3jftq9e86c438">
          Quieres aprender a entrenar fútbol, preparar ejercicios y dirigir
          jugadores,{' '}
          <span className="bg-gold px-1 text-pitch" data-id="element-132" data-mp="1p2auo9xpevkk">
            pero no sabes por dónde empezar.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-pitch/80" data-id="element-133" data-mp="1k5al3p1nbaop">
          Si estás comenzando desde cero o quieres mejorar tus entrenamientos,
          probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-134" data-mp="sdjmrl9n8wqh">
          {problems.map((problem, i) => {
          const Icon = ICONS[i];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-pitch bg-cream p-2.5 text-left" data-id="element-135" data-mp="x6cu8gwhyj69" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-pitch text-gold" aria-hidden="true" data-id="element-136" data-mp="1c1izh1nrqdyj">
                  <Icon size={16} data-id="element-137" data-mp="3dtnljwil6h1c" />
                </span>
                <div data-id="element-138" data-mp="3dv8krzfuio5j">
                  <h3 className="font-sub text-sm font-extrabold leading-tight" data-id="element-139" data-mp="3huqzuekzk50g">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-pitch/80 sm:text-sm" data-id="element-140" data-mp="p11z23jrcpl2">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}